import { render, staticRenderFns } from "./configuracionLayout.vue?vue&type=template&id=3983b294&scoped=true&"
import script from "./configuracionLayout.vue?vue&type=script&lang=js&"
export * from "./configuracionLayout.vue?vue&type=script&lang=js&"
import style0 from "./configuracionLayout.vue?vue&type=style&index=0&id=3983b294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983b294",
  null
  
)

export default component.exports